import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { VouchersService } from 'src/app/services/vouchers.service';
import { InvitesService } from 'src/app/services/invites.service';
import { Voucher } from 'src/app/interfaces/voucher';
import { selectAllVouchers, selectVouchersLoading } from 'src/app/store/selectors/voucher.selectors';
import * as moment from 'moment';
import * as VoucherActions from 'src/app/store/actions/voucher.actions';
import { selectMgmConfig, selectMgmConfigLoading, selectVouchersProvider } from 'src/app/store/selectors/mgm.selectors';

@Component({
  selector: 'vouchers-page',
  styleUrls: ['./vouchers.component.scss'],
  templateUrl: './vouchers.component.html',
  providers: [VouchersService, InvitesService]
})
export class VouchersComponent implements OnInit {

  loadingVouchers$: Observable<boolean>;
  loadingMgmConfig$: Observable<boolean>;
  vouchers$: Observable<Voucher[]>;
  voucherProvider$: Observable<any>;
  mgmConfig$: Observable<any>;

  currentTab = 'available';
  availableVouchers = [];
  expiredVouchers = [];
  voucherProvider: any;
  vouchersToGenerate = [];
  loadingVouchers = false;
  loadingMgmConfig = false;
  vouchers = [];

  breadcrumbItems = [
    { url: '/', title: 'Início' },
    { url: '/indique', title: 'Indique Allya' },
    { title: 'Meus Vouchers' },
  ];

  constructor(
    private vouchersService: VouchersService,
    private invitesService: InvitesService,
    private router: Router,
    private store: Store
  ) {}

  ngOnInit() {
    this.loadingVouchers$ = this.store.pipe(select(selectVouchersLoading));
    this.loadingMgmConfig$ = this.store.pipe(select(selectMgmConfigLoading));
    this.voucherProvider$ = this.store.pipe(select(selectVouchersProvider));
    this.vouchers$ = this.store.pipe(select(selectAllVouchers));
    this.mgmConfig$ = this.store.pipe(select(selectMgmConfig));

    this.loadingVouchers$.subscribe(loadingVouchers => this.loadingVouchers = loadingVouchers);
    this.loadingMgmConfig$.subscribe(loadingMgm => this.loadingMgmConfig = loadingMgm);
    this.voucherProvider$.subscribe(provider => this.voucherProvider = provider);

    this.vouchers$.subscribe(vouchers => {
      this.vouchers = vouchers;
      this.availableVouchers = vouchers.filter(el => moment(el.expired_voucher).isSameOrAfter(moment()));
      this.expiredVouchers = vouchers.filter(el => moment(el.expired_voucher).isBefore(moment()));
    });

    this.mgmConfig$.subscribe(this.checkConfig);
  }

  get loading() {
    return this.loadingVouchers || this.loadingMgmConfig;
  }

  checkConfig = (config) => {
    if (config) {
      if (config.isActive) {
        if (!this.loading) {
          this.store.dispatch(VoucherActions.retrieve());
        }
        this.checkVoucherAvailability();
      } else {
        this.router.navigate(['/home']);
      }
    }
  }

  checkVoucherAvailability() {
    this.vouchersService.canGenerate().subscribe(({canGenerateVoucher}) => {
      if (canGenerateVoucher) {
        this.vouchersToGenerate = [{
          amount: this.voucherProvider.amount,
          vouchers_provider: this.voucherProvider
        }];
      }
    });
  }

}
